import { ctrlKey } from '../shell/shortcuts';
import type { PaletteEntry } from '../shell/palette';
import { strings } from '../strings';
import { useOptionalDock } from './context';

const p = strings.dock.palette;

/**
 * The command palette's tool-window commands (spec 6.1.11): per window available on the page Show (with its
 * shortcut), Dock left/right/bottom and Float; then Reset layout, Dock all and Hide all.
 */
export function useDockCommands(): PaletteEntry[] {
  const dock = useOptionalDock();
  if (!dock) return [];
  const entries: PaletteEntry[] = [];
  for (const { id, title, shortcut } of dock.definitions) {
    if (!dock.available.has(id)) continue;
    entries.push(
      {
        id: `window-show-${id}`,
        group: 'commands',
        label: p.show(title),
        keys: [ctrlKey(), 'Shift', String(shortcut)],
        // After the palette has returned focus to where it was, so focus can move into the window.
        run: () => setTimeout(() => dock.show(id, { focus: true }), 0),
      },
      {
        id: `window-left-${id}`,
        group: 'commands',
        label: p.dockLeft(title),
        run: () => dock.dock(id, 'left'),
      },
      {
        id: `window-right-${id}`,
        group: 'commands',
        label: p.dockRight(title),
        run: () => dock.dock(id, 'right'),
      },
      {
        id: `window-bottom-${id}`,
        group: 'commands',
        label: p.dockBottom(title),
        run: () => dock.dock(id, 'bottom'),
      },
      { id: `window-float-${id}`, group: 'commands', label: p.float(title), run: () => dock.float(id) },
    );
  }
  entries.push(
    { id: 'layout-reset', group: 'commands', label: p.resetLayout, run: dock.resetLayout },
    { id: 'layout-dock-all', group: 'commands', label: p.dockAll, run: dock.dockAll },
    { id: 'layout-hide-all', group: 'commands', label: p.hideAll, run: dock.hideAll },
  );
  return entries;
}
